/** @jsx jsx */
import React, { useMemo, useRef, useEffect, useState } from 'react'
import { jsx, useThemeUI } from 'theme-ui'
import { css } from '@emotion/react'
import { graphql, useStaticQuery } from 'gatsby'
import { get, find } from 'lodash'
import { atom, useSetAtom } from 'jotai'
import { motion, AnimatePresence } from 'framer-motion'

import { hardwareAccelerate } from '../../styles/css'

import { settings as animationSettings } from '../../lib/animation'

const query = graphql`
  query {
    work: allWpWork {
      nodes {
        uri
      }
    }
  }
`

const pageVariants = {
  initial: {
    opacity: 0,
  },
  in: {
    opacity: 1,
    transition: {
      type: 'tween',
      duration: 0.9,
      ease: animationSettings.easings.easeInOut,
    },
  },
  out: {
    opacity: 0,
    transition: {
      type: 'tween',
      duration: 0.3,
      ease: animationSettings.easings.easeInOut,
    },
  },
}

const PageTransition = (props) => {
  const { children, path } = props
  const data = useStaticQuery(query)
  const [isWork] = useMemo(() => {
    const isWork = !!find(get(data, 'work.nodes'), { uri: path })
    return [isWork]
  }, [path, data])

  const pageKey = isWork ? `single-work` : path

  return (
    <AnimatePresence exitBeforeEnter={true}>
      <motion.div
        key={pageKey}
        sx={{ position: 'relative', zIndex: 1 }}
        variants={pageVariants}
        initial="initial"
        animate="in"
        exit="out"
      >
        {children}
      </motion.div>
    </AnimatePresence>
  )
}

export default PageTransition
